
import MenuModal from "@/components/ui/MenuModal.vue";
import SearchIcon from "@/components/ui/icon/SearchIcon.vue";
import SiteSearch from "@/components/ui/SiteSearch.vue";

export default {
  name: "SearchWraper",
  components: {
    SearchIcon,
    SiteSearch,
    MenuModal,
  },
  data: () => ({
    openSearch: false,
  }),
  methods: {
    open() {
      this.openSearch = !this.openSearch;
    },
    close() {
      this.openSearch = false;
    },
  },
};
